import { useMemo } from 'react';
import { TenderVote, VoteType } from '@/actions/dtos/tender/vote';
import { useEnumTranslations } from '@/hooks/useEnumTranslations';

export interface VoteStats {
  positiveCount: number;
  negativeCount: number;
  hasUserPositiveVote: boolean;
  hasUserNegativeVote: boolean;
  userVote: TenderVote | null;
}

export const useVoteStats = (votes: TenderVote[], userId?: string) => {
  const { t } = useEnumTranslations();

  const voteStats = useMemo(() => {
    const positiveVotes = votes.filter((vote) => vote.type === VoteType.POSITIVE);
    const negativeVotes = votes.filter((vote) => vote.type === VoteType.NEGATIVE);
    const userVote = userId ? votes.find((vote) => vote.voter.id === userId) || null : null;

    return {
      positiveCount: positiveVotes.length,
      negativeCount: negativeVotes.length,
      hasUserPositiveVote: userVote?.type === VoteType.POSITIVE,
      hasUserNegativeVote: userVote?.type === VoteType.NEGATIVE,
      userVote,
    };
  }, [votes, userId]);

  const getVoteDisplay = useMemo(() => {
    return (count: number, hasUserVote: boolean) => {
      if (hasUserVote) {
        return t('Vote_Count', { count: count - 1 });
      }
      return count.toString();
    };
  }, [t]);

  return {
    ...voteStats,
    getVoteDisplay,
  };
};
